import { Component, useEffect } from "react";
import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Pillars from "@/components/Pillars";
import HowItWorks from "@/components/HowItWorks";
import Stats from "@/components/Stats";
import Waitlist from "@/components/Waitlist";
import Footer from "@/components/Footer";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        if (this.state.error) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-void px-6 text-center">
                    <div>
                        <p className="font-display text-xl font-bold text-white">Something broke.</p>
                        <p className="mt-2 text-sm text-slate-400">Refresh the page to try again.</p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <BrowserRouter>
                <div className="min-h-screen bg-void text-slate-100">
                    <Navbar />
                    <main>
                        <Hero />
                        <Marquee />
                        <Pillars />
                        <HowItWorks />
                        <Stats />
                        <Waitlist />
                    </main>
                    <Footer />
                    <Toaster theme="dark" position="bottom-right" richColors />
                </div>
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;